import store from "../../store";

const initialValues = () => {
  const values = store.getState().consoleBrok1;

  return {
    ...values,
  };
};

export default initialValues;



// WEBPACK FOOTER //
// ./src/Screens/ConsoleBrok/initialValues2.js